import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
export function PrimaryCTA() {
  return <SectionWrapper className="bg-white py-20 text-center" data-id="element-224">
      <h2 className="font-sans text-4xl md:text-5xl font-bold text-ink mb-10" data-id="element-225">
        ¿Qué pasa si no haces nada?
      </h2>

      <div className="space-y-4 font-sans text-xl text-ink-mid mb-12 font-medium" data-id="element-226">
        <p data-id="element-227">Mañana habrá otra crisis.</p>
        <p data-id="element-228">Y vas a improvisar otra vez.</p>
        <p data-id="element-229">Y vas a sentir lo mismo de siempre.</p>
        <p className="text-2xl text-coral font-bold pt-4" data-id="element-230">
          O puedes tener un plan en las próximas 2 horas.
        </p>
      </div>

      <div className="max-w-2xl mx-auto" data-id="element-231">
        <CTAButton fullWidth data-id="element-232">SÍ QUIERO EL PROTOCOLO AHORA</CTAButton>
      </div>
    </SectionWrapper>;
}